import { importSagaPromises } from '@dbh/user-area-bookings-redux';

const ssrUserAreaUserBookings={importSagaPromises};var reducersAndSagas = [ssrUserAreaUserBookings];

export { reducersAndSagas as default };
